var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert-triangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96461 6.10986L4.30791 16.3099C4.29977 16.3245 4.29128 16.339 4.28242 16.3532C4.01126 16.789 3.96604 17.1008 4.02277 17.294C4.31056 18.274 5.23097 19 6.3307 19H17.6706C18.7703 19 19.6907 18.274 19.9785 17.294C20.0352 17.1008 19.99 16.789 19.7188 16.3532C19.71 16.339 19.7015 16.3245 19.6934 16.3099L14.0366 6.10986C13.0967 4.63005 10.9046 4.63005 9.96461 6.10986ZM8.25429 5.07268C9.97404 2.3091 14.0272 2.30911 15.747 5.07268C15.7558 5.08692 15.7643 5.10137 15.7725 5.11604L21.4309 15.3191C21.8148 15.9436 22.1883 16.8669 21.8975 17.8574C21.3627 19.6785 19.6688 21 17.6706 21H6.3307C4.33249 21 2.63854 19.6785 2.10379 17.8575C1.81293 16.8669 2.18645 15.9436 2.57037 15.3191L8.2288 5.11603C8.23693 5.10137 8.24543 5.08692 8.25429 5.07268ZM12.0006 7.41447C12.5529 7.41447 13.0006 7.86219 13.0006 8.41447V12.9C13.0006 13.4523 12.5529 13.9 12.0006 13.9C11.4483 13.9 11.0006 13.4523 11.0006 12.9V8.41447C11.0006 7.86219 11.4483 7.41447 12.0006 7.41447ZM12.0006 15.2248C12.5529 15.2248 13.0006 15.6725 13.0006 16.2248V16.2642C13.0006 16.8165 12.5529 17.2642 12.0006 17.2642C11.4483 17.2642 11.0006 16.8165 11.0006 16.2642V16.2248C11.0006 15.6725 11.4483 15.2248 12.0006 15.2248Z",
    fill: "#FEB273"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarning);
export default __webpack_public_path__ + "static/media/ic-warning.afdcc8b64f95a454db3420c4bf5adffc.svg";
export { ForwardRef as ReactComponent };